import style from "./CircularProgress.module.css";

function CircularProgress({
	progress,
	radius = 40,
	stroke = 15,
	color,
	children,
}) {
	const normalizedRadius = radius - stroke * 0.5;
	const circumference = 2 * Math.PI * normalizedRadius;
	const strokeDashoffset = circumference - progress * circumference;

	return (
		<div className={style.circleContainer}>
			<svg height={radius * 2} width={radius * 2}>
				<circle
					stroke="rgba(var(--primary-rgb), 0.1)"
					fill="transparent"
					strokeWidth={stroke}
					r={normalizedRadius}
					cx={radius}
					cy={radius}
				/>
				<circle
					stroke={color}
					fill="transparent"
					strokeWidth={stroke}
					strokeLinecap="round"
					strokeDasharray={circumference + " " + circumference}
					strokeDashoffset={strokeDashoffset}
					r={normalizedRadius}
					cx={radius}
					cy={radius}
					transform={`rotate(90 ${radius} ${radius})`}
				/>
			</svg>
			<div className={style.circleContent}>{children}</div>
		</div>
	);
}
export default CircularProgress;
